<template>
    <div class="l-wrap">
        <div class="l-constrained l-content" :class="{'padding-bottom-75': dataLoading && !ready}">
            <div v-loading="! ready || loading" :element-loading-text="dataLoading ? 'Data is still being processed ...' : ''">

                <el-form v-if="ready">
                    <proposal-header
                        :proposal="proposal"
                        :tab_form="form_data.header"
                        @save="save"
                        @saveAndPreview="saveAndPreview"
                    />

                    <el-tabs
                        v-model="activeTab"
                        type="border-card"
                    >
                        <el-tab-pane label="Jobs" name="jobs">
                            <proposal-tab-jobs
                                :proposal="proposal"
                                :tab_form="form_data.jobs"
                                :maps="setup.maps"
                            />
                        </el-tab-pane>

                        <template v-for="number in 3">
                            <el-tab-pane :name="'option' + number" :key="number">
                                <span slot="label">
                                    Option {{ number }}

                                    <template v-if="number === 2">
                                        - primary
                                    </template>
                                    <template v-if="! form_data['pricing_option' + number].is_active">
                                        (disabled)
                                    </template>
                                    <template v-else-if="form_data['pricing_option' + number].price">
                                        ({{ money(form_data['pricing_option' + number].price) }})
                                    </template>
                                </span>

                                <proposal-tab-pricing-option
                                    :proposal="proposal"
                                    :tab_form="form_data['pricing_option' + number]"
                                    :form_data="form_data"
                                    :results="results"
                                    :number="number"
                                >
                                </proposal-tab-pricing-option>
                            </el-tab-pane>
                        </template>

                        <el-tab-pane label="Proposal" name="proposal">
                            <proposal-tab-proposal-document
                                v-if="activeTab === 'proposal'"
                                :proposal="proposal"
                                :tab_form="form_data.proposal_document"
                                :form_data="form_data"
                            />
                        </el-tab-pane>
                        <el-tab-pane label="Billing" name="billing">
                            <proposal-tab-billing
                                :proposal="proposal"
                                :tab_form="form_data.billing"
                            />
                        </el-tab-pane>
                    </el-tabs>

                    <div style="display: flex; gap: 1rem; justify-content: end; margin: 2rem 0">
                        <btn cssClass="btn btn-secondary" icon="fas fa-external-link" :click="saveAndPreview">Save and Preview</btn>
                        <btn icon="fas fa-save" :click="save">Save</btn>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import ProposalHeader from './detail/proposal-header.vue';
import ProposalTabJobs from './detail/proposal-tab-jobs.vue';
import ProposalTabPricingOption from './detail/proposal-tab-pricing-option.vue';
import ProposalTabProposalDocument from './detail/proposal-tab-proposal-document.vue';
import ProposalTabBilling from './detail/proposal-tab-billing.vue';

export default {
    components: {
        ProposalHeader,
        ProposalTabJobs,
        ProposalTabPricingOption,
        ProposalTabProposalDocument,
        ProposalTabBilling,
    },
    props: [
        'id',
    ],
    data() {
        return {
            proposal: null,
            form_data: null,
            results: null,
            setup: null,

            ready: false,
            loading: false,
            refresh_index: 1,
            dirty: false,
            dataLoading: false,

            activeTab: 'jobs',

            pusher: {
                all_users: null,
            },
        };
    },
    methods: {
        refresh() {
            return axios.get(url(`admin/proposal2/${this.id}/data`))
                .then((response) => {
                    if (response.data.error !== undefined && response.data.error === 'not-ready') {
                        this.dataLoading = true;
                        this.loading = true;
                    } else {
                        this.proposal = response.data.proposal;
                        this.form_data = response.data.form_data;
                        this.results = response.data.results;
                        this.setup = response.data.setup;

                        this.ready = true;
                        this.dataLoading = false;
                        this.loading = false;
                    }
                });
        },
        save(preview = false) {
            this.loading = true;

            return axios.post(url(`admin/proposal2/${this.id}/update`), this.form_data).then((result) => {
                ++this.refresh_index;

                if(preview) {
                    this.previewProposal();
                }

                return this.refresh();
            }).finally(() => {
                this.dirty = false;
            });
        },
        saveAndPreview() {
            this.save(true);
        },
        previewProposal() {
            window.open(url(`sales-proposal/${this.proposal.key}`), `proposal_${this.proposal.key}`);
        },
    },
    created() {
        this.pusher.all_users = Echo.private(`jb-all-users`);
        this.pusher.all_users.listen('.proposal-data-cached', (event) => {
            if (event.proposalId === this.id) {
                this.refresh();
            }
        });
    },
    beforeDestroy() {
        this.pusher.all_users.stopListening('.proposal-data-cached');
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style scoped>
    ::v-deep h2.tr-mt {
        margin-top: 50px;
    }
    ::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before, h2.is-required:before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
    }

    ::v-deep div.section-inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%
    }

    ::v-deep .large-checkbox .el-checkbox {
        display: flex;
        align-items: center;
    }

    ::v-deep .large-checkbox .el-checkbox__label {
        font-size: 2.0rem;
        line-height: 1.5;
    }

    ::v-deep div .fr-box {
        overflow-y: auto;
        border: 1px solid #DCDFE6;
    }

    .padding-bottom-75 {
        padding-bottom: 75px;
    }
</style>
